import "./App.css";
import AllRoutes from "./Router/AllRoutes";
import AllNavbar from "./components/Navbar/AllNavbar";

function App() {
  return (
    <div className="App">
      <AllNavbar />
      <AllRoutes />
    </div>
  );
}

export default App;
